<template>
  <div>
    <el-drawer :visible.sync="changVisible" :title="title" size="300px" :before-close="$onClose" destroy-on-close>
      <el-checkbox-group v-model="checkList">
        <!-- <ul>
          <li v-for="item in items" :key="item">
            <el-checkbox label=" {{ item }}" disabled></el-checkbox>
          </li>
        </ul> -->
        <div>
          <el-checkbox label="学号" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="中文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="英文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="专业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="荣誉时间"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="荣誉内容"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友类别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="是否本硕连读"></el-checkbox>
        </div>
      </el-checkbox-group>
    </el-drawer>
  </div>
</template>

<script>
import * as Constant from '@/utils/constant.js'

export default {
  data() {
    return {
      changVisible: false,
      title: '勾选表格显示字段',
      items: Constant.journals_table_lable_base,
      checkList: []
    }
  },
  methods: {
    $onClose(done) {
      this.$emit('toBackCheckList', this.checkList)
      done()
    },
    //页面初始化时加载的事件
    show(list) {
      this.checkList = list
      this.changVisible = true
    },
    // 还原
    onBack() {
      this.changVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
div {
  margin-left: 30px;
}
.this_table {
  width: 50%;
  margin: 0 auto;
}
.btn_back {
  float: right;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/honorsTableLabelDrawer.vue